/**
 * Lessons Service — API для расписания занятий
 */

/**
 * Получить расписание на неделю
 */
export async function getWeekSchedule(organizationId, weekStart = null) {
  const params = new URLSearchParams();
  if (weekStart) params.append('week_start', weekStart);

  const response = await fetch(
    `/api/organizations/${organizationId}/lessons/?${params}`,
    { credentials: 'include' }
  );
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Не удалось загрузить расписание');
  }
  return response.json();
}

/**
 * Обновить занятие (статус, тип, замена, перенос)
 */
export async function updateLesson(organizationId, lessonId, data) {
  const response = await fetch(
    `/api/organizations/${organizationId}/lessons/${lessonId}`,
    {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify(data),
    }
  );
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Не удалось обновить занятие');
  }
  return response.json();
}

/**
 * Получить сводное расписание по всем организациям
 * filters: { organization_ids, statuses, lesson_types, teacher_ids } — массивы
 */
export async function getGlobalSchedule(weekStart = null, filters = {}) {
  const params = new URLSearchParams();
  if (weekStart) params.append('week_start', weekStart);
  if (filters.organization_ids?.length) params.append('organization_ids', filters.organization_ids.join(','));
  if (filters.statuses?.length) params.append('statuses', filters.statuses.join(','));
  if (filters.lesson_types?.length) params.append('lesson_types', filters.lesson_types.join(','));
  if (filters.teacher_ids?.length) params.append('teacher_ids', filters.teacher_ids.join(','));

  const response = await fetch(`/api/lessons/global/?${params}`, { credentials: 'include' });
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Не удалось загрузить сводное расписание');
  }
  return response.json();
}

/**
 * Получить опции для фильтров сводного расписания
 */
export async function getGlobalScheduleFilterOptions() {
  const response = await fetch('/api/lessons/global/filter-options', { credentials: 'include' });
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Не удалось загрузить опции фильтров');
  }
  return response.json();
}

/**
 * Принудительная генерация занятий на 4 недели
 */
export async function generateLessons(organizationId) {
  const response = await fetch(
    `/api/organizations/${organizationId}/lessons/generate`,
    {
      method: 'POST',
      credentials: 'include',
    }
  );
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Не удалось сгенерировать занятия');
  }
  return response.json();
}
